/**
 * Url parsing utility.  Creates a subset of window.location instance with added convenience properties.
 * Any combination properties are not included, with the exception of href.
 * Query and hash params are parsed into a object for easy consumption.
 * @name app-url
 * @return {object}
 */
define('app-url/app-url',['require','exports','module'],function(require,exports,module){
	var regex_query=/([^?=&]+)(?:=([^&]*))?/g,
		regex_hash=/([^#=&,]+)(?:=([^&,]*))?/g,

		EMPTY="",
        EQUAL="=",
        AMP = "&",
        COMMA=",",
		TRUE=true,
        specialProps = {
            params      : {
                target : "search",
                divider: AMP
            },
            hashParams  : {
                target : "hash",
                divider: COMMA
            }
        },
		rSECURE=/((?:\w+tp(s)?)|file)(:)/,
		OWN=Object.prototype.hasOwnProperty,
		fragmenter=document.createElement('a'),
		decode=decodeURIComponent,
		cache={},
		props="href,hash,search,pathname,protocol,host,hostname,port".split(','),
		tmp,undef,
		isArray = Array.isArray || function(ar){
			return (ar instanceof Array);
		};



	function safePush(ar,val){
		if(!isArray(ar)){
			ar=[ar];
		}
		ar.push(val);
		return ar;
	}

	function param_parser($0, $1, $2) {
		var val= $2==undef ? TRUE : decode($2);
		tmp[$1]=OWN.call(tmp,$1) ? safePush(tmp[$1],val) : val;
    }

    function param_set(params,divider){
        params = params || {};
        var key,
            ret=[];

        for(key in params){
            ret.push(key+EQUAL+params[key]);
        }
        return ret.join(divider||AMP);
    }

    function list_copy(to,from,list){
		var i=0,
			len=list.length,
			key;

    	for(;i<len;i++){
			key=list[i];
			if((key in from) && (from[key]!==EMPTY || !(key in to))){
	    		to[key]=from[key];
	    	}
    	}

    }
	function isSecure(protocol){
    	return !!protocol.replace(rSECURE,"$2");
    }
    /**
     * Parsed url object constructor.
     * @name AppUrl
     * @param {string} url url string to be parsed.  Accepts full, relative and absolute urls.
     */
	function Url(url){
    	this.originalUrl=url;
    	this.setProperty('href',url);

    	// console.log(JSON.stringify(this,null,'\t'));
	};	
	var proto=Url.prototype={

		setProperty : function(prop,val){
			// Start parsing
			fragmenter.href=this.href;

            if(prop in specialProps){
                var special = specialProps[prop];
                prop = special.target;
                val = param_set(val,special.divider);
            }
			//Update the value on the parsed object
			fragmenter[prop]=(val+"");

			list_copy(this,fragmenter,props);

			this.origin=this.origin||this.protocol+'//'+this.hostname;
			this.isSecure=isSecure(this.protocol);
			this.params=(tmp={},(this.search||"").replace(regex_query,param_parser),tmp);    	
			this.hashParams=(tmp={},(this.hash||"").replace(regex_hash,param_parser),tmp);
		},
		/**
		 * Convenient string cohersion method.
		 * @return {string} full url as a string
		 */
		toString :function(){		
	    	return this.href;
	    }
	}
	return function(url){
		url= url===undef ? window.location+EMPTY : url;
		return (cache[url]||new Url(url));
	};
});
